// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'location-check-solid';

export const Component = () => (
  <path d='M18.223 2.442C16.595.814 14.631 0 12.333 0c-2.299 0-4.263.814-5.89 2.442C4.813 4.07 4 6.034 4 8.332c0 2.156.814 4.79 2.395 7.903 1.58 3.113 3.208 5.652 4.789 7.711.287.383.67.575 1.149.575s.862-.191 1.149-.575c1.58-2.06 3.209-4.645 4.79-7.759 1.58-3.064 2.394-5.699 2.394-7.854 0-2.3-.814-4.263-2.443-5.89Zm-1.628 4.263-4.886 4.932a.434.434 0 0 1-.335.144.434.434 0 0 1-.335-.144L8.118 9.195a.435.435 0 0 1-.191-.383c0-.335.143-.478.478-.478.097 0 .192.047.336.096l2.586 2.203 4.597-4.598a.434.434 0 0 1 .335-.144c.336 0 .48.144.48.48a.433.433 0 0 1-.144.334Z' />
);

export const viewBox = '0 0 25 25';
